import Handler from '@/core/domain/usecase/handler';

const createTruckDriverRepository = (axios) => async (data) => {
  try {
    const response = await axios.post(`/truck-driver`,
      data
    )
    return response.data
  } catch (err) {
    if (err.isAxiosError) {
      throw new Handler().trataErro(err)
    } else {
      throw err
    }
  }
}

export default createTruckDriverRepository
